import React from 'react';
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import cx from "classnames"
import './styles.scss'

const Roadmap = (props) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allDataYaml {
            edges {
              node {
                top {
                  roadmap {
                    heading
                    description
                    phases {
                      phase1 {
                        title
                        description
                      }
                      phase2 {
                        title
                        description
                      }                     
                      phase3 {
                        title
                        description
                      }
                    }
                  }
                }
                language
              }
            }
          }
          roadmapPhase1: file(relativePath: {eq: "top/roadmap/roadmap-phase1.svg"}) {
            name
            publicURL
          }
          roadmapPhase2: file(relativePath: {eq: "top/roadmap/roadmap-phase2.svg"}) {
            name
            publicURL
          }
          roadmapPhase3: file(relativePath: {eq: "top/roadmap/roadmap-phase3.svg"}) {
            name
            publicURL
          }
        }
      `}
      render={({ allDataYaml: { edges }, roadmapPhase1, roadmapPhase2, roadmapPhase3}) => {
        const { language } = props
        const { node: { top: { roadmap } } } = edges.find(({node}) => node.language === language)
        const { heading, description, phases } = roadmap

        return <div className="top-roadmap">
          <h3>{heading}</h3>
          <div className="roadmap-description">{description}</div>
          <ul className="roadmap-phases d-flex justify-content-between align-items-center align-items-xl-start">
            <li className={cx("roadmap-phase", language)} >
              <div className="phase-arrow d-none d-xl-block">Phase1</div>
              <div className="phase-circle d-block d-xl-none"><span>Phase</span><span>1</span></div>
              <div className="roadmap-phase-content">
                <div className="title">{phases.phase1.title}</div>
                <div className="description">{phases.phase1.description}</div>
                <div className="phase-image"><img src={roadmapPhase1.publicURL} alt={roadmapPhase1.name} loading="lazy" decoding="async" /></div>
              </div>
              <div className="phase-arrow-sp d-block d-xl-none"></div>
            </li>
            <li className={cx("roadmap-phase", language)}>
              <div className="phase-arrow d-none d-xl-block">Phase2</div>
              <div className="phase-circle d-block d-xl-none"><span>Phase</span><span>2</span></div>
              <div className="roadmap-phase-content">
                <div className="title">{phases.phase2.title}</div>
                <div className="description">{phases.phase2.description}</div>
                <div className="phase-image"><img src={roadmapPhase2.publicURL} alt={roadmapPhase2.name} loading="lazy" decoding="async" /></div>
              </div>
              <div className="phase-arrow-sp d-block d-xl-none"></div>
            </li>
            <li className={cx("roadmap-phase", language)}>
              <div className="phase-arrow d-none d-xl-block">Phase3</div>
              <div className="phase-circle d-block d-xl-none"><span>Phase</span><span>3</span></div>
              <div className="roadmap-phase-content">
                <div className="title">{phases.phase3.title}</div>
                <div className="description">{phases.phase3.description}</div>
                <div className="phase-image"><img src={roadmapPhase3.publicURL} alt={roadmapPhase3.name} loading="lazy" decoding="async" /></div>
              </div>
            </li>
          </ul>
        </div>
      }}
    />
  )
}

export default Roadmap;
